module.exports = __webpack_public_path__ + "static/media/image3.19046f09.jpg";